const MAX_SHOW_UNREAD = 99

/**
 * @param count
 * @return {string}
 */
export function unreadIndicator (count) {
  return (count > MAX_SHOW_UNREAD) ? `${MAX_SHOW_UNREAD}+` : count
}
